import { useContext } from "react";
import { IconButton } from "@mui/material";
import { LightMode, DarkMode } from "@mui/icons-material";
import { motion, AnimatePresence } from "framer-motion";
import { ColorModeContext } from "../App";

const MotionIconButton = motion(IconButton);

export const ModeToggleButton = () => {
  const { toggleColorMode, mode } = useContext(ColorModeContext);

  const iconVariants = {
    initial: { rotate: -180, scale: 0 },
    animate: {
      rotate: 0,
      scale: 1,
      transition: {
        type: "spring",
        stiffness: 200,
        damping: 15
      }
    },
    exit: {
      rotate: 180,
      scale: 0,
      transition: {
        duration: 0.2
      }
    }
  };

  return (
    <MotionIconButton
      onClick={toggleColorMode}
      color="inherit"
      whileHover={{ scale: 1.1, rotate: 15 }}
      whileTap={{ scale: 0.9 }}
      sx={{
        marginTop: 0,
        position: "relative",
      }}
    >
      <AnimatePresence mode="wait" initial={false}>
        {mode === 'dark' ? (
          <motion.div
            key="light"
            variants={iconVariants}
            initial="initial"
            animate="animate"
            exit="exit"
            style={{ display: "flex", alignItems: "center", justifyContent: "center" }}
          >
            <LightMode />
          </motion.div>
        ) : (
          <motion.div
            key="dark"
            variants={iconVariants}
            initial="initial"
            animate="animate"
            exit="exit"
            style={{ display: "flex", alignItems: "center", justifyContent: "center" }}
          >
            <DarkMode />
          </motion.div>
        )}
      </AnimatePresence>
    </MotionIconButton>
  );
};